import { Link } from "react-router";
import { Layout } from "@/components/layout/Layout";

/**
 * 404.
 *
 * The 2020 version logged `screen_view` with a `screen_name` parameter, which
 * GA4 ignores — the reserved event takes `firebase_screen`. Those page views
 * were silently dropped for the life of the app. Analytics is handled in
 * `data/firebase.ts` now and this screen does not log anything itself.
 */
export function NotFound() {
  return (
    <Layout title="Page not found">
      <div className="mx-auto max-w-xl px-6 py-24">
        <p className="eyebrow">404</p>
        <h1 className="statement mt-4 -ml-1">Not here.</h1>
        <p className="mt-6 text-lg">
          That page does not exist. It may have been moved, or the link may be from an older
          version of the site.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/" className="btn-primary">
            Home
          </Link>
          <Link to="/trade/list" className="btn-outline">
            Your trades
          </Link>
        </div>
      </div>
    </Layout>
  );
}
